(() => {
  const fields = ['title', 'product_type', 'tag', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  const stopwords = new Set(['a', 'an', 'and', 'the', 'for', 'of', 'with', 'or', '&']);
  const isScoped = (query) => query.startsWith('(title:"') && query.includes(' OR variants.barcode:"');
  const display = (query) => {
    if (!isScoped(query)) return query;
    return Array.from(query.matchAll(/(?:^| AND )\(title:"((?:\\.|[^"\\])*)"/g), (match) => match[1].replace(/\\([\\"])/g, '$1')).join(' ');
  };
  const quote = (term) => `"${term.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
  const expand = (query) => {
    if (isScoped(query)) return query;
    const words = query.replace(/[“”"]/g, '').trim().split(/\s+/u).filter(Boolean);
    const significant = words.filter((word) => !stopwords.has(word.toLowerCase()));
    return (significant.length ? significant : words).map((word) => {
      const choices = fields.map((field) => `${field}:${quote(word)}`);
      if (words.length > 1) choices.push(`variants.sku:${quote(query.trim())}`, `variants.barcode:${quote(query.trim())}`);
      if (/^[a-z]{3,}$/i.test(word)) {
        const alternate = /ies$/i.test(word) ? word.slice(0, -3) + 'y' : /s$/i.test(word) && !/(ss|us)$/i.test(word) ? word.slice(0, -1) : word + 's';
        choices.push(`tag:${quote(alternate)}`);
      }
      return `(${choices.join(' OR ')})`;
    }).join(' AND ');
  };
  const current = new URL(window.location.href);
  const searchUrl = document.currentScript.dataset.searchUrl;
  window.LakeviewSearch = { expand, display, isScoped };
  if (current.pathname === searchUrl && current.searchParams.get('q')?.trim()) {
    const query = current.searchParams.get('q');
    if (!isScoped(query) || current.searchParams.get('type') !== 'product') {
      current.searchParams.set('q', expand(query));
      current.searchParams.set('type', 'product');
      current.searchParams.delete('page');
      window.location.replace(current.href);
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || new URL(form.action).pathname !== searchUrl) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || !input.value.trim() || event.defaultPrevented) return;
    event.preventDefault();
    const url = new URL(form.action);
    const params = new URLSearchParams(new FormData(form));
    params.set('q', expand(input.value));
    params.set('type', 'product');
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) params.set('preview_theme_id', previewTheme);
    url.search = params.toString();
    window.location.assign(url.href);
  });
})();
